import dayjs from "utils/dayjs";

const yup = require("yup");

const autoFunding = yup.object().shape({
  amount: yup
    .number()
    .required("Amount is required")
    .positive("Amount must be positive")
    .test("is-decimal", "Amount can have at most 2 decimal places", (value) =>
      value ? /^\d+(\.\d{1,2})?$/.test(value) : true,
    ),
  transferDate: yup
    .string()
    .required("Transfer Date is required")
    .test("transferDate", function (value) {
      const { isRepeatJob } = this.parent;
      if (isRepeatJob) {
        return dayjs(value).isAfter(dayjs().endOf("day"))
          ? true
          : this.createError({
              message: "Scheduled Transfers must be in the future",
            });
      } else {
        return dayjs(value).isAfter(dayjs().startOf("day"))
          ? true
          : this.createError({
              message: "Transfer Date must be today or in the future",
            });
      }
    }),
  confirmTransfer: yup
    .boolean()
    .test(
      "confirmTransfer",
      "Please confirm the transfer",
      (value) => value === true,
    ),
  comment: yup.string(),
  isRepeatJob: yup.boolean(),
  repeatOnDay: yup.boolean(),
  repeatNeverEnd: yup.boolean(),
  repeatDayOfMonth: yup.number().when(["repeatOnDay", "isRepeatJob"], {
    is: (repeatOnDay, isRepeatJob) => {
      return repeatOnDay && isRepeatJob;
    },
    then: (schema) => schema.required("This field is required"),
  }),
  repeatDayOfWeek: yup.number().when(["repeatOnDay", "isRepeatJob"], {
    is: (repeatOnDay, isRepeatJob) => {
      return !repeatOnDay && isRepeatJob;
    },
    then: (schema) => schema.required("This field is required"),
  }),
  repeatWeekday: yup.number().when(["repeatOnDay", "isRepeatJob"], {
    is: (repeatOnDay, isRepeatJob) => {
      return !repeatOnDay && isRepeatJob;
    },
    then: (schema) => schema.required("This field is required"),
  }),
  repeatEndOn: yup.string().when(["repeatNeverEnd", "isRepeatJob"], {
    is: (repeatNeverEnd, isRepeatJob) => {
      return !repeatNeverEnd && isRepeatJob;
    },
    then: (schema) => schema.required("This field is required"),
  }),
});

export default autoFunding;
